var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"d-flex justify-center align-center mt-3 text-uppercase",attrs:{"cols":"12"}},[_c('h1',{domProps:{"textContent":_vm._s(_vm.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }